import React, { useState } from 'react';
import { Modal, Button, Alert, ListGroup } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
const ErrorModal = ({ errorModalShow, onClose, errorFileUrl, isSuccess }) => {
 console.log('Raw errorFileUrl:', errorFileUrl);

  // Ensure body is parsed correctly
  const parsedBody = typeof errorFileUrl?.body === 'string' ? JSON.parse(errorFileUrl.body) : errorFileUrl?.body || {};
  
  const issueFileUrl = parsedBody?.issue_file_url;
  const warningFileUrl = parsedBody?.warning_file_url;

  

  // Assign URLs directly if they are valid strings
  const downloadUrls = {
    issueFileUrl: typeof issueFileUrl === "string" ? issueFileUrl : issueFileUrl?.url || null,
    warningFileUrl: typeof warningFileUrl === "string" ? warningFileUrl : warningFileUrl?.url || null,
  };

  const hasIssueFile = !!downloadUrls.issueFileUrl;
  const hasWarningFile = !!downloadUrls.warningFileUrl;

  

  return (
    <Modal show={errorModalShow} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isSuccess ? 'Issues' : 'Error Issues'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isSuccess && hasIssueFile && (
          <Alert variant="danger">
            Validation issues were found. Please review the following files, correct the issues, and upload again.
          </Alert>
        )}
        {isSuccess && hasWarningFile && (
          <Alert variant="warning">
            Validation completed successfully with warnings. You can proceed, but we recommend reviewing the warning file.
          </Alert>
        )}
        {(hasIssueFile || hasWarningFile) ? (
          <ListGroup>
            {hasIssueFile && (
              <ListGroup.Item className="d-flex align-items-center">
                <div className="w-50">Issues File</div>
                <div className="w-50 text-end">
                  <Button
                    variant="outline-primary"
                    href={downloadUrls.issueFileUrl}
                    size="sm"
                    
                  >
                   
                      <FaDownload /> 
                     Download
                  </Button>
                </div>
              </ListGroup.Item>
            )}
            {hasWarningFile && (
              <ListGroup.Item className="d-flex align-items-center">
                <div className="w-50">Warnings File</div>
                <div className="w-50 text-end">
                  <Button
                    variant="outline-warning"
                    href={downloadUrls.warningFileUrl}
                    size="sm"
                    // onClick={() => handleDownload(downloadUrls.warningFileUrl, "Warnings_File.csv")}
                    // disabled = {waringDownLoadLoader}
                  >
                    <FaDownload /> Download
                  </Button>
                </div>
              </ListGroup.Item>
            )}
          </ListGroup>
        ) : (
          <p>No error or warning files available.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;



